import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { useFetch } from '../../hooks/useFetch';
import { Prefix } from '../../../services/prefix';
import api from '../../../services/api';
import { CardTracks, ButtonRange } from './editRangesStyles';

const EditRanges = ({ sensor, idEquipmentModel }) => {
  const [defaultTracks, setDefaultTracks] = useState([]);
  const [errors, setErrors] = useState([]);

  const listTracks = useFetch(
    Prefix.replace(/[\\"]/g, '') + '/monitor-profile-attributes?id=' + sensor
  );

  useEffect(() => {
    if (listTracks.data?.models?.data) {
      const tracks = listTracks.data.models.data.map((map) => ({
        id: map.id,
        max: parseFloat(map.max),
        min: parseFloat(map.min),
        safety_margin: parseFloat(map.safety_margin),
        id_profile_attribute: map.id_profile_attribute,
        safety_margin_time: map.safety_margin_time,
        variation: map.variation,
        original: {
          min: parseFloat(map.profile_attribute.min),
          max: parseFloat(map.profile_attribute.max)
        }
      }));
      setDefaultTracks(tracks);
      setErrors(tracks.map(() => ({ min: false, max: false })));
    }
  }, [listTracks.data]);

  const validateField = (track) => {
    const minError = track.min < track.original.min || track.min > track.original.max;
    const maxError = track.max < track.original.min || track.max > track.original.max;
    return { min: minError, max: maxError };
  };

  const handleInputChange = (id, field, value) => {
    let newValue = field === 'variation' ? value : parseFloat(value);
    if (field !== 'variation' && isNaN(newValue)) newValue = 0;

    setDefaultTracks((prev) =>
      prev.map((track, index) => (index === id ? { ...track, [field]: newValue } : track))
    );
  };

  useEffect(() => {
    if (defaultTracks.length) {
      const newErrors = defaultTracks.map((track) => validateField(track));
      setErrors(newErrors);
    }
  }, [defaultTracks]);

  const handleUpdate = async () => {
    try {
      await Promise.all(
        defaultTracks.map((track) =>
          api.put(
            `${Prefix.replace(/[\\"]/g, '')}/monitor-profile-attributes/${track.id}`,
            {
              max: track.max,
              min: track.min,
              safety_margin: track.safety_margin,
              id_profile_attribute: track.id_profile_attribute,
              safety_margin_time: track.safety_margin_time,
              variation: !track.variation ? 0 : track.variation.replace(',', '.')
            }
          )
        )
      );
      Swal.fire({
        icon: 'success',
        title: 'Uow...',
        text: 'Suas alterações foram realizadas com sucesso!',
        confirmButtonText: 'Fechar'
      }).then(() => {
        listTracks.mutate();
      });
    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Houve um problema com a alteração! Por favor tente novamente mais tarde.',
        confirmButtonText: 'Fechar'
      });
    }
  };

  const isDisabled = errors.some((err) => err.min || err.max);

  return (
    <div className="customerStep">
      <form>
        {defaultTracks.map((track, key) => (
          <Row key={track.id} className="mb-4">
            <Col xs={12}>
              <CardTracks>
                <h3 className="text-center mb-3">
                  Faixa de {listTracks.data.models.data[key].profile_attribute.unit_of_measure.measure.name}
                </h3>

                {/* Linha Mínima e Máxima */}
                <Row className="mb-1">
                  <Col xs={12} md={6} className="mb-3">
                    <label>Mínima</label>
                    <input
                      type="number"
                      className={`form-control ${errors[key]?.min ? 'invalid' : ''}`}
                      value={track.min}
                      onChange={(e) => handleInputChange(key, 'min', e.target.value)}
                    />
                    {errors[key]?.min && (
                      <small style={{ color: 'red' }}>
                        Valor deve estar entre {track.original.min} e {track.original.max}
                      </small>
                    )}
                  </Col>
                  <Col xs={12} md={6} className="mb-3">
                    <label>Máxima</label>
                    <input
                      type="number"
                      className={`form-control ${errors[key]?.max ? 'invalid' : ''}`}
                      value={track.max}
                      onChange={(e) => handleInputChange(key, 'max', e.target.value)}
                    />
                    {errors[key]?.max && (
                      <small style={{ color: 'red' }}>
                        Valor deve estar entre {track.original.min} e {track.original.max}
                      </small>
                    )}
                  </Col>
                </Row>

                {/* Linha Margem segura */}
                <Row className="mb-3">
                  <Col xs={12}>
                    <label>Margem segura</label>
                    <input
                      type="number"
                      className="form-control"
                      step={0.25}
                      value={track.safety_margin}
                      onChange={(e) => handleInputChange(key, 'safety_margin', e.target.value)}
                    />
                  </Col>
                </Row>

                {/* Linha Tempo offline e Variação */}
                <Row>
                  <Col xs={12} md={6} className="mb-3">
                    <label>Tempo offline</label>
                    <input
                      type="number"
                      className="form-control"
                      value={track.safety_margin_time}
                      onChange={(e) => handleInputChange(key, 'safety_margin_time', e.target.value)}
                    />
                  </Col>
                  <Col xs={12} md={6} className="mb-3">
                    <label>Variação</label>
                    <input
                      type="text"
                      className="form-control"
                      value={track.variation}
                      onChange={(e) => handleInputChange(key, 'variation', e.target.value)}
                    />
                  </Col>
                </Row>
              </CardTracks>
            </Col>
          </Row>
        ))}

        <Row>
          <Col className="d-flex justify-content-center mt-4">
            <ButtonRange
              type="button"
              onClick={handleUpdate}
              disabled={isDisabled}
              className={isDisabled ? 'disabled-btn' : ''}
            >
              Atualizar
            </ButtonRange>
          </Col>
        </Row>
      </form>
    </div>
  );
};

export default EditRanges;
